module.exports = new __parcel__URL__("carrot.6193f6d7.svg").toString();